<template>
  <div class="home_wrap">
    <!-- Header -->
    <div class="headerBg">
      <van-row style="padding: 15px 0px">
        <van-col span="2" class="headerItem">
          <router-link to="/index">
            <div class="headerTop">
              <img src="../images/common/backArrow.png" class="headerImg" />
            </div>
          </router-link>
        </van-col>
        <van-col span="5" class="headerItem">
          <router-link to="/info/guide">
            <div class="headerTop">
              <img src="../images/common/Guide.png" class="headerImg" />
              <p class="headerItemText">{{ $t("guide.guide") }}</p>
            </div>
          </router-link>
        </van-col>
        <van-col span="5" class="headerItem">
          <router-link to="/about">
            <div class="headerTop">
              <img src="../images/common/About.png" class="headerImg" />
              <p class="headerItemText">{{ $t("about.about") }}</p>
            </div>
          </router-link>
        </van-col>
        <van-col span="4" class="headerItem">
          <div class="headerTop">
            <a
              href="https://www.boxofficemojo.com/"
              target="_blank"
              class="headerTop"
            >
              <img src="../images/common/Mojo.png" class="headerImg" />
              <p class="headerItemText">{{ $t("mojo.mojo") }}</p>
            </a>
          </div>
        </van-col>
        <van-col span="4" class="headerItem">
          <div class="headerTop" @click="$router.push('/language')">
            <img src="../images/common/Lang.png" class="headerImg" />
            <p class="headerItemText">{{ $t("header.language") }}</p>
          </div>
        </van-col>
        <van-col span="4" class="headerItem">
          <div class="headerTop">
            <a href="https://t.me/naomiafm" target="_blank" class="headerTop">
              <img
                src="../images/common/CustomerService.png"
                class="headerImg"
              />
              <p class="headerItemText">{{ $t("header.customerSupport") }}</p>
            </a>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- end header -->
    <van-row>
      <van-col span="24">
        <video
          ref="videoRef"
          src=""
          id="video-container"
          width="100%"
          controls
        ></video>
      </van-col>
    </van-row>
    <!-- --------------------- movie image list ---------------------- -->
    <van-row>
      <van-swipe id="movieIndicator" :width="130">
        <van-swipe-item v-for="(item, index) in images" :key="index"
          ><div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              :src="item"
              @click="showImage(index)"
            /></div
        ></van-swipe-item>
        <!-- <van-swipe-item>
          <div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              src="../images/remove/movie2.png"
            /></div
        ></van-swipe-item>
        <van-swipe-item>
          <div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              src="../images/remove/movie3.png"
            /></div
        ></van-swipe-item>
        <van-swipe-item
          ><div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              src="../images/remove/movie1.png"
            /></div
        ></van-swipe-item>
        <van-swipe-item>
          <div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              src="../images/remove/movie2.png"
            /></div
        ></van-swipe-item>
        <van-swipe-item>
          <div class="filmContainer">
            <img
              style="object-fit: fill; width: 100%"
              src="../images/remove/movie3.png"
            /></div
        ></van-swipe-item> -->
      </van-swipe>
    </van-row>
    <!-- ------------------------ movie info ------------------- -->
    <van-row style="padding: 10px 4px 0px; align-items: center; display: flex">
      <van-col span="20">
        <div>
          <span class="moviepoit" v-for="(item, i) in synopsis" :key="i">{{
            item
          }}</span>
        </div>
      </van-col>
      <van-col span="4" style="text-align: right"
        ><img
          @click="favorite()"
          :src="
            data.isFav
              ? require('@/views/images/home/favourite.png')
              : require('@/views/images/home/unfavourite.png')
          "
          style="height: 30px; width: auto; padding-right: 6px"
      /></van-col>
    </van-row>
    <van-row style="padding: 10px 20px">
      <van-col span="24" class="listStyle">
        <ul style="list-style: disc">
          <li>
            <span>{{ data["desc_" + lang] }}</span>
          </li>
        </ul>
      </van-col>
    </van-row>
    <div class="movieContainers">
      <van-row>
        <van-col span="6">
          <p class="movieTitle">{{ $t("movieDetail.name") }} :</p>
        </van-col>
        <van-col span="18">
          <p class="movieDesc">{{ data[lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="6">
          <p class="movieTitle">{{ $t("movieDetail.director") }} :</p>
        </van-col>
        <van-col span="18">
          <p class="movieDesc">{{ data["director_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="6">
          <p class="movieTitle">{{ $t("movieDetail.writer") }} :</p>
        </van-col>
        <van-col span="18">
          <p class="movieDesc">{{ data["writer_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="4">
          <p class="movieTitle">{{ $t("movieDetail.stars") }} :</p>
        </van-col>
        <van-col span="20">
          <van-row>
            <van-col
              span="4"
              style="text-align: center; margin-bottom: 5px"
              v-for="(item, index) in castArray"
              :key="index"
            >
              <img :src="item.Image" style="height: 70px; width: auto" />
            </van-col>
          </van-row>
          <p class="movieTitle" style="font-weight: unset">
            {{ `${castArray.map((a) => a.Name).join(", ")}` }}
          </p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.location") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["location_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.releasedDate") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ getDate(data.release_date) }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.countriesReigion") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["country_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.productionCompany") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["product_company_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.technicalSpecs") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["technical_specs_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.languages") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["languages_" + lang] }}</p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.Synopsis") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">
            {{ data["sypnosis_content_" + lang] }}
          </p>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="10">
          <p class="movieTitle">{{ $t("movieDetail.synopsisGenre") }} :</p>
        </van-col>
        <van-col span="14">
          <p class="movieDesc">{{ data["sypnosis_" + lang] }}</p>
        </van-col>
      </van-row>
    </div>

    <!-- <van-row style="padding: 20px 0px">
      <van-col span="24" style="text-align: center">
        <img
          src="../images/movieitem/invest.png"
          style="height: 100px; width: auto"
        />
      </van-col>
    </van-row> -->
    <van-row style="padding-bottom: 40px; text-align: center">
      <van-col span="24" class="investButton">
        <!-- <router-link :to="'/movieinvest/' + item_id"> -->
        <div class="investBtnBg" @click="confirmPopup = true">
          <p class="investBtnText">{{ $t("movieDetail.wantInvest") }}</p>
        </div>

        <!-- </router-link> -->
      </van-col>
    </van-row>
    <van-image-preview
      v-model="show"
      :images="images"
      :maxZoom="10"
      :showIndex="false"
      :closeable="true"
      :startPosition="imagePrevStart"
    >
    </van-image-preview>

    <!-- ===================== invest duration popup ============= -->
    <!-- <van-popup
      id="ssssa"
      v-model="investDurationPopup"
      round
      :style="{ width: '90%' }"
      :close-on-click-overlay="false"
    >
      <div style="padding: 10px 15px">
        <van-row>
          <van-col span="24" style="text-align: right">
            <img
              src="../images/common/Vector.png"
              @click="investDurationPopup = false"
              style="width: 18px"
            />
          </van-col>
        </van-row>
        <van-row class="detailRow" style="margin-left: 10px;">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.balance")
            }}</span></van-col
          >
        </van-row>
        
        <van-popover
          @select="onSelectDuration"
          v-model="investDurationPopover"
          :actions="durationList"
          placement="bottom-start"
          id="durationPopOver" 
        >
          <template #reference>
            <van-row  class="investDuraion" @click="(investDurationPopover = !investDurationPopover)">
              <van-col span="20" >{{
                investDurationId == ""
                  ? $t("durationPopup.investDuration")
                  : investText
              }}</van-col>
              <van-col>
                <img
                  src="../../assets/images/drop.png"
                  style="width: 20px; height: 20px"
                />
              </van-col>
            </van-row>
          </template>
        </van-popover> -->

        <!-- ---------- confirm Btn -------- -->
        <!-- <van-row class="detailRow">
          <div
            class="payBtnBg"
            style="padding: 10px 0px"
            @click="onConfirmDuration"
          >
            <van-col span="24">
              <p class="confirmInvest">{{ $t("investPopup.confirm") }}</p>
            </van-col>
          </div>
        </van-row>
      </div>
    </van-popup> -->
    <!-- ===================== confirm popup ============= -->
    <van-popup
      v-model="confirmPopup"
      round
      :style="{ width: '90%' }"
      :close-on-click-overlay="false"
    >
      <div style="padding: 10px 15px">
        <van-row>
          <van-col span="24" style="text-align: right">
            <img
              src="../images/common/Vector.png"
              @click="closeConfirmPopup"
              style="width: 18px"
            />
          </van-col>
        </van-row>
        <!-- ------------- Amount ---------------- -->
        <van-row class="amountRow">
          <van-col span="12"
            ><span class="investInfo"
              >{{ $t("investPopup.Amount") }} :</span
            ></van-col
          >
          <van-col span="12" style="text-align: right">
            <van-field v-model="amount" type="number" class="investAmount" />
          </van-col>
        </van-row>

        <!-- ------------- Family Name ---------------- -->
        <van-row class="detailRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.balance")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <span class="investInfoDetail">{{ userData.money }}</span>
          </van-col>
        </van-row>
        <!-- ------------- Payment Password ---------------- -->
        <van-row class="detailRow">
          <span class="investInfo">{{
            $t("investPopup.paymentPassword")
          }}</span>
          <van-row class="payPwrdRow">
            <div style="text-align: left">
              <van-field
                v-model="payPwrd"
                input-align="left"
                style="text-align: left !important"
                type="password"
                class="payPasswordField"
              />
            </div>
          </van-row>
        </van-row>

        <!-- ------------- Please Input Your OTP Code :---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="24"
            ><span class="investInfo">{{
              $t("investPopup.otpCode")
            }}</span></van-col
          >
        </van-row> -->
        <!-- ---------------- OTP code ------------- -->
        <!-- <van-row class="amountRow">
          <van-col span="24" style="text-align: right">
            <van-field
              v-model="otpCode"
              type="number"
              class="OTPCode"
              :placeholder="$t('investPopup.otpCodePlaceholder')"
            />
          </van-col>
        </van-row> -->
        <!-- ---------- confirm Btn -------- -->
        <van-row class="detailRow">
          <div
            class="payBtnBg"
            style="padding: 10px 0px"
            @click="investForAFilm"
          >
            <van-col span="24">
              <p class="confirmInvest">{{ $t("investPopup.confirm") }}</p>
            </van-col>
          </div>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import {
  Icon,
  Col,
  Row,
  Swipe,
  SwipeItem,
  ImagePreview,
  Toast,
  Popup,
  Field,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Picker,
  Popover,
} from "vant";
import Fetch from "../../utils/fetch";
import moment from "moment";
Vue.use(Icon)
  .use(Row)
  .use(Col)
  .use(Swipe)
  .use(SwipeItem)
  .use(ImagePreview)
  .use(Popup)
  .use(Field)
  .use(Dialog)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Picker)
  .use(Popover);

export default {
  name: "movieDetail",
  components: {
    Header,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      item_id: null,
      show: false,
      imagePrevStart: 0,
      images: [],
      synopsis: [],
      data: {},
      castArray: [],
      confirmPopup: false,
      amount: 0,
      otpCode: "",
      userData: {},
      payPwrd: "",
      investDurationPopup: false,
      // investDurationId: "",
      durationList: [],
      investDurationPopover: false,
      investText: "",
    };
  },
  mounted() {
    this.item_id = this.$route.params.id;
    this.loadData();
    this.getUserData();
    // this.getInvestTemplates();
  },
  methods: {
    showImage(position) {
      // this.images = [image];

      this.imagePrevStart = position;
      this.show = true;
    },
    onSwipeLeft(even, start, end) {
      if (end["X"] - start["X"] > 60) {
        this.$router.go(-1);
      }
    },
    loadData() {
      Fetch("/movie/item", { id: this.item_id }).then((res) => {
        if (res.code == 1) {
          this.data = res.data;
          this.images = JSON.parse(this.data.image_array);
          this.loadVideo(this.data.video);
          this.synopsis = this.data["sypnosis_" + this.lang].split(",");
          this.castArray = JSON.parse(this.data[this.lang + "_content_array"]);
        }
      });
    },
    loadVideo(link) {
      this.$refs.videoRef.src = link;
      this.$refs.videoRef.pause();
    },
    favorite() {
      this.data.isFav ? this.delFav(this.data.id) : this.addFav(this.data.id);
    },
    addFav(id) {
      Fetch("/movie/addUserItem", {
        item_id: id,
      }).then((r) => {
        if (r.code == 1) {
          this.data.isFav = true;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    delFav(id) {
      Fetch("/movie/removeUserItem", {
        item_id: id,
      }).then((r) => {
        if (r.code == 1) {
          this.data.isFav = false;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    // getInvestTemplates() {
    //   Fetch("/movie/invest_templates").then((r) => {
    //     if (r.code == 1) {
    //       r.data.forEach((elem, index) => {
    //         this.durationList.push({
    //           text: (
    //             <van-row class="durationContainer" style="margin: 20px 5px">
    //               <van-row>
    //                 <van-col span="12">
    //                   <van-row>{this.$t("durationPopup.duration")}</van-row>
                    
    //                 </van-col>
    //                 <van-col span="12">
    //                   <van-row>: {elem.invest_duration} {this.$t("durationPopup.days")}</van-row>
                     
    //                 </van-col>
    //               </van-row>
    //               <van-row style="margin-top:10px">
    //                 <van-col span="12">
    //                   <van-row>
    //                     {this.$t("durationPopup.percentage")}
    //                   </van-row>
    //                 </van-col>
    //                 <van-col span="12">
    //                   <van-row>: {elem.interest_rate} %</van-row>
    //                 </van-col>
    //               </van-row>
    //             </van-row>
    //           ),
    //           value: elem.id,
    //           displayValue:
    //             elem.invest_duration +
    //             " " +
    //             this.$t("durationPopup.days") +
    //             " " +
    //             elem.interest_rate +
    //             "%",
    //         });
    //       });
    //     } else {
    //       Toast.fail(r.msg[this.lang]);
    //     }
    //   });
    // },
    investForAFilm() {
      if (!this.userData.withdraw_pass_set) {
        Dialog.confirm({
          cancelButtonText: this.$t("confirmDialog.cancel"),
          confirmButtonText: this.$t("confirmDialog.confirm"),
          message: this.$t("confirmDialog.content"),
        })
          .then(() => {
            this.$router.push({
              path: "/setpaypwd",
            });
          })
          .catch(() => {});

        return;
      }
      if (this.amount == 0) return;

      Fetch("/movie/invest", {
        item_id: this.item_id,
        amount: this.amount,
        password: this.payPwrd,
        // interest_template: this.investDurationId,
      }).then((r) => {
        if (r.code == 1) {
          this.closeConfirmPopup();
          this.$router.push("/movieinvest/" + r.data);
          Toast.success(r.msg[this.lang]);
        } else if (r.code == 3) {
          Dialog.confirm({
            cancelButtonText: this.$t("confirmDialog.cancel"),
            confirmButtonText: this.$t("confirmDialog.confirm"),
            message: this.$t("confirmDialog.insufficientAccountBalance"),
          })
            .then(() => {
              this.$router.push({
                path: "/member",
              });
            })
            .catch(() => {});
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    showConfirmPopup() {
      this.confirmPopup = true;
    },
    closeConfirmPopup() {
      this.confirmPopup = false;
    },
    getUserData() {
      Fetch("/user/info").then((r) => {
        this.userData = r.data;
      });
    },
    // onSelectDuration(item) {
    //   this.investDurationId = item.value;
    //   this.investText = item.displayValue;
    // },
    // onConfirmDuration() {
    //   if (this.investDurationId != "") {
    //     this.investDurationPopover = false;
    //     this.confirmPopup = true;
    //     this.investDurationPopup = false;
    //   } else {
    //     Toast.fail(this.$t("durationPopup.select"));
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/detailed_screen.png");
  background-size: 100% 100%;
}

.movieContainers {
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 15px;
  margin: 8px;
  background: #ebebeb29;
}

.filmContainer {
  margin: 8px 0px 15px 6px;
}

.moviepoit {
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #ffffff;
  padding: 4px 10px;
  border-radius: 15px;
  width: fit-content;
  text-align: center;
  margin: 2px 2px;
  float: left;
}

.listStyle li {
  color: #ff8917;
  font-size: 16px;
}

.listStyle span {
  color: #ffffff;
  font-size: 13px;
}

.movieTitle {
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  word-break: break-word;
}

.movieDesc {
  color: #ffffff;
  font-size: 13px;
}
.actorName {
  color: #ffffff;
  font-size: 11px;
}

.actorDesc {
  color: #ffffff;
  font-size: 9px;
}

.investBtnBg {
  background: url("../images/movieitem/investBtn.png");
  background-size: 100% 100%;
}

.investButton {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.investBtnText {
  font-size: 20px;
  padding: 10px 20px;
  color: #ffffff;
}
// ---------- header style
.headerBg {
  background: url("../images/common/HeaderBg.png");
  background-size: 100% 100%;
}

.headerItem {
  align-items: center;
  display: flex;
  justify-content: center;
}

.headerImg {
  width: 18px;
}

.headerItemText {
  color: #ffffff;
  font-size: 14px;
  padding-left: 6px;
}

.headerTop {
  display: flex;
  align-items: center;
}
.payBtnBg {
  background: url("../images/common/investBtn.png");
  background-size: 100% 100%;
  align-items: center;
  display: flex;
  padding: 16px 0px;
  margin: 10px;
}

.payMethod {
  color: #ffffff;
  font-size: 22px;
  text-align: center;
  font-weight: 700;
}

.amountDetail {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}

.amountValue {
  color: #ffffff;
  font-size: 14px;
  text-align: right;
}

.investInfo {
  color: #000000;
  font-size: 14px;
  font-weight: 700;
}

.investAmount {
  padding: 0 !important;
}

.payPasswordField {
  padding: 0 !important;
}

.OTPCode {
  padding: 0 !important;
}

.amountRow {
  align-items: center;
  display: flex;
  background: #e8eded;
  padding: 5px 10px;
  margin-top: 10px;
}

.payPwrdRow {
  display: flex;
  background: #e8eded;
  padding: 5px 10px;
  margin-top: 10px;
}

.investInfoDetail {
  color: #000000;
  font-size: 14px;
}

.detailRow {
  padding-top: 20px;
}
.investDuraion {
  margin: 15px 10px 0px 10px;
  font-size: 15px;
  text-align: left;
  word-break: break-all;
  justify-content: center;
  align-items: center;
  display: flex;
  border-width: 4px;
  border: solid;
  border-color: #f3da2f;
  padding: 5px;
  border-radius: 10px;
}

.confirmInvest {
  color: #000000;
  font-size: 22px;
  text-align: center;
}
.durationContainer {
  /* border-radius: 25px; */
  margin: 15px;
  height: 75px;
  background-size: 100% 100%;
  width: 260px;
  padding: 5px;
  
}
// ------ end header style
</style>
<style>
#progressBar .van-progress {
  border-radius: 20px;
}

#progressBar .van-progress__pivot {
  background-color: unset !important;
  color: #000000;
  font-size: 14px;
  /* right: 0; */
  font-weight: 700;
  /* left: unset !important; */
}

#movieIndicator .van-swipe__indicator {
  background-color: #140b0b;
}

#movieIndicator .van-swipe__indicator--active {
  background-color: #f3da2f;
}

#movieIndicator .van-swipe__indicators {
  bottom: 4px;
}
.investAmount .van-field__control {
  color: #ff0000;
  font-size: 18px;
  text-align: right;
  background: #e8eded;
  font-weight: 700;
}

.payPasswordField .van-field__control {
  color: #ff0000;
  font-size: 18px;
  text-align: left;
  background: #e8eded;
  font-weight: 700;
}

.OTPCode .van-field__control {
  color: #000000;
  font-size: 14px;
  background: #e8eded;
}
.van-popover--light .van-popover__content {
  background-size: 100% 100%;
  color: #000000;
  box-shadow: rgb(243 243 255 / 25%) 0px 50px 100px -20px,
    rgb(236 227 227 / 30%) 0px 30px 60px -30px,
    rgb(190 213 235 / 35%) 0px -2px 6px 0px inset;

  display: inline-block !important;
  align-items: left;
  max-height: 60vh;
  overflow-y: scroll;
}
.van-popover__content {
  width: 90%;
}
.van-popover__action {
  height: 65px;
}
.van-popover__wrapper {
  display: block;
}
</style>

